<div *ngIf="showInstallButton" class="install-banner">
    <span *ngIf="!installMessageForAndroid && installMessageForIos" class="install-text">
    <b>Add myPrimeRx to Home Screen:  </b>
    <b> Tap </b> <img src="assets/images/ios_share.png" alt="Share" class="install-icon" />➜<img src="assets/images/add_to_homescreen.png" alt="Add" class="install-icon top_0px"/>
  </span>
   <span *ngIf="installMessageForAndroid && !installMessageForIos" class="install-text">
    Add myPrimeRx to Home Screen
  </span>
  <div class="install-actions">
    <a (click)="installApp()" *ngIf="installMessageForAndroid && !installMessageForIos && isInstallable()" class="install-link">Tap here</a>
    <span class="close-icon" (click)="dismissBanner()">✖</span>
  </div>
</div>
<router-outlet></router-outlet>
<app-loader></app-loader>